<template>
  <span v-if="content">
    <template v-for="item in content">
      <announcement-banner-content v-bind="item" :key="item.text" />
    </template>
  </span>
  <a
    v-else-if="link"
    :href="link.url"
    :target="link.external ? '_blank' : '_self'"
    >{{ text }}</a
  >
  <span v-else>{{ text }}</span>
</template>

<script>
export default {
  name: 'AnnouncementBannerContent',

  props: {
    text: {
      default: '',
      type: [String, Array]
    },
    link: {
      default: null,
      type: Object
    }
  },

  computed: {
    content() {
      const pattern = /({{\s*link\s+\|[^}]+}})/i
      if (!this.link || !pattern.test(this.text)) {
        return null
      }
      return this.text
        .split(pattern)
        .filter(Boolean)
        .map(item => {
          if (pattern.test(item)) {
            const text = item
              .replace(/({{\s*link\s+\||[}]+)/g, '')
              .replace(/(^\s+|\s+$)/, ' ')
            return { text, link: this.link }
          }
          return { text: item }
        })
    }
  }
}
</script>
